import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_58aca9c2-2cb6-4ff9-a615-17272856b112/artifacts/wb3ejkz9_Logo%20-%20Transparent.png";

export default function MaintenancePage({ message }) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center px-4 relative overflow-hidden" data-testid="maintenance-page">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#78BE20]/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative z-10 max-w-lg w-full text-center space-y-10">
        {/* Logo */}
        <div>
          <img
            src={LOGO_URL}
            alt="Tech Distribution"
            className="h-14 mx-auto opacity-90"
          />
        </div>

        {/* Divider line */}
        <div className="w-16 h-[2px] bg-[#78BE20]/40 mx-auto" />

        {/* Content */}
        <div className="space-y-4">
          <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">
            We'll Be Right Back
          </h1>
          <p className="text-zinc-400 text-base sm:text-lg leading-relaxed max-w-md mx-auto">
            {message || 'We are currently performing scheduled maintenance. Please check back soon.'}
          </p>
        </div>

        {/* Status indicator */}
        <div className="pt-2">
          <div className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-zinc-900/80 border border-zinc-800 rounded-full backdrop-blur-sm">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#78BE20] opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#78BE20]" />
            </span>
            <span className="text-sm text-zinc-400">Maintenance in progress</span>
          </div>
        </div>

        {/* Contact info */}
        <div className="pt-4">
          <p className="text-zinc-600 text-sm">
            Need urgent help? Contact us at{' '}
            <a href="mailto:sales@techdistribution.com.au" className="text-[#78BE20]/70 hover:text-[#78BE20] transition-colors">
              sales@techdistribution.com.au
            </a>
          </p>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#78BE20]/30 to-transparent" />
    </div>
  );
}
